import type { WorkOrderStatus } from '@backoffice-frontend/graphql'
import {
  WorkOrderServiceItem,
  WorkOrderStatus as WorkOrderStatusEnum,
} from '@backoffice-frontend/graphql'

type WorkOrderCandidate = {
  createdAt: string
  id: string
  serviceItem: WorkOrderServiceItem
  status: WorkOrderStatus
  statusChangedAt?: string | null
  vehicle?: {
    id: string
  } | null
}

const activeStatuses = [
  WorkOrderStatusEnum.Open,
  WorkOrderStatusEnum.InProgress,
] as const

const getLastUpdateTimestamp = (workOrder: WorkOrderCandidate) =>
  new Date(workOrder.statusChangedAt ?? workOrder.createdAt).getTime()

export const getActiveInFieldSupportWorkOrder = <
  TWorkOrder extends WorkOrderCandidate,
>(
  workOrders: TWorkOrder[],
  vehicleId: string,
) =>
  workOrders
    .filter(
      workOrder =>
        workOrder.vehicle?.id === vehicleId &&
        workOrder.serviceItem === WorkOrderServiceItem.InFieldSupport &&
        activeStatuses.includes(
          workOrder.status as (typeof activeStatuses)[number],
        ),
    )
    .sort(
      (left, right) =>
        getLastUpdateTimestamp(right) - getLastUpdateTimestamp(left),
    )
    .at(0)

export const getInFieldSupportStatus = (
  workOrder?: WorkOrderCandidate,
): 'requested' | 'dispatched' | undefined => {
  if (!workOrder) return undefined

  return workOrder.status === WorkOrderStatusEnum.Open
    ? 'requested'
    : 'dispatched'
}
